import { FieldsOptions } from '@sim/form';
import { FilterFieldsOptions } from '@src/app/ui/ui.module';
import { Status } from './status';

export interface SourceArchivial {
  id: string;
  titolo: string;
  tipo: string;
  collocazione: string;
  fondo: string;
  serie: string;
  segnatura: string;
  datazione: string;
  dataInizio: string;
  dataFine: string;
  mittente: string;
  destinatario: string;
  lingua: string;
  evento: string;
  contesto: string;
  descrizione: string;
  previewUrl: string;
  trascrizione: string;
  tag: string[];
  /** Id of the image file */
  immagine: string;
  /** Id of the file */
  file: string;
  status: Status;
  createdAt: string;
  updatedAt: string;
  /** Id of the user */
  user: string;
}

export interface SourceArchivialFilter {
  titolo: string;
  tipo: string;
}

export const SourceArchivialMeta: FieldsOptions<SourceArchivial> = {
  collocazione: {},
  contesto: {},
  createdAt: {},
  dataFine: {},
  dataInizio: {},
  datazione: {},
  descrizione: {},
  destinatario: {},
  evento: {},
  /** Id of the file */
  file: {},
  fondo: {},
  id: {},
  /** Id of the image file */
  immagine: {},
  lingua: {},
  mittente: {},
  segnatura: {},
  serie: {},
  status: { value: Status.STATUS_DRAFT },
  tag: { type: 'array' },
  tipo: {},
  titolo: {},
  trascrizione: {},
  updatedAt: {},
  user: {},
};

export const SourceArchivialFilterMeta: FilterFieldsOptions<SourceArchivialFilter> = {
  tipo: { operator: 'begins_with' },
  titolo: { operator: 'contains' },
};
